module.exports = __webpack_public_path__ + "img/dvs-video-min.0b60ae02.gif";